import "./Indicator.css";

const Indicator: React.FC<{
  value: number | string | boolean;
  label?: string | null;
  measurement?: string | null;
  signed?: boolean;
}> = ({ value, label = null, measurement = null, signed = false }) => {
  var negativeStyle = "";
  if (signed && typeof value === "number") {
    negativeStyle = value > 0 ? "positive" : "negative";
  }

  return (
    <div className="metric indicator">
      <h4>{label}</h4>
      <p className={negativeStyle}>
        {value}
        {measurement && ` ${measurement}`}
      </p>
    </div>
  );
};

export default Indicator;
